/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Matching_Assets_In_This_CatInputs */

const en_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching assets in this category. Try adjusting your filters.`)
};

const es_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay activos coincidentes en esta categoría. Intenta ajustar tus filtros.`)
};

const fr_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun bien correspondant dans cette catégorie. Essayez d'ajuster vos filtres.`)
};

const de_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine passenden Assets in dieser Kategorie. Versuche, deine Filter anzupassen.`)
};

const ja_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このカテゴリに一致するアセットがありません。絞り込み条件を変更してみてください。`)
};

const zh_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此类别中未找到匹配的资产。请尝试调整您的筛选条件。`)
};

const ar_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد أصول مطابقة في هذه الفئة. حاول تعديل عوامل التصفية الخاصة بك.`)
};

const id_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada aset yang cocok di kategori ini. Coba sesuaikan filter Anda.`)
};

const it_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna risorsa corrispondente in questa categoria. Prova a modificare i tuoi filtri.`)
};

const ru_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой категории нет подходящих активов. Попробуйте изменить фильтры.`)
};

const pt_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum ativo correspondente nesta categoria. Tente ajustar seus filtros.`)
};

const ko_no_matching_assets_in_this_cat = /** @type {(inputs: No_Matching_Assets_In_This_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 카테고리에 일치하는 에셋이 없습니다. 필터를 조정해 보세요.`)
};

/**
* | output |
* | --- |
* | "No matching assets in this category. Try adjusting your filters." |
*
* @param {No_Matching_Assets_In_This_CatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_matching_assets_in_this_cat = /** @type {((inputs?: No_Matching_Assets_In_This_CatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Matching_Assets_In_This_CatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_matching_assets_in_this_cat(inputs)
	if (locale === "es") return es_no_matching_assets_in_this_cat(inputs)
	if (locale === "fr") return fr_no_matching_assets_in_this_cat(inputs)
	if (locale === "de") return de_no_matching_assets_in_this_cat(inputs)
	if (locale === "ja") return ja_no_matching_assets_in_this_cat(inputs)
	if (locale === "zh") return zh_no_matching_assets_in_this_cat(inputs)
	if (locale === "ar") return ar_no_matching_assets_in_this_cat(inputs)
	if (locale === "id") return id_no_matching_assets_in_this_cat(inputs)
	if (locale === "it") return it_no_matching_assets_in_this_cat(inputs)
	if (locale === "ru") return ru_no_matching_assets_in_this_cat(inputs)
	if (locale === "pt") return pt_no_matching_assets_in_this_cat(inputs)
	return ko_no_matching_assets_in_this_cat(inputs)
});